import FilterSet from "../../utils/FilterSet";

const initalState = {
  show: false,
  render: false,
  value: 0,
  open: false,
  newRun: false,
  finalRun: false,
  orders: [],
  tasks:[],
  redirect: false,
  completed: false,
  status:'',
  newVariance:false,
  statusFilterList: new FilterSet(),
  parts: [],
  priceFilterValue: 0
}
export const dataReducer = (state = initalState, action) => {
  switch (action.type) {
    case 'SHOW_ACCEPTED':
      return {
        ...state,
        show: action.payload.show,
      }
    case 'RERENDER':
      return {
        ...state,
        render: action.payload.render,
      }
    case 'GET_VALUE':
      return {
        ...state,
        value: action.payload.value,
      }
    case 'CLEAR_VALUE':
      return {
        ...state,
        clearValue: action.payload.clearValue,
      }
    case 'IS_MODAL_OPEN':
      return {
        ...state,
        open: action.payload.open,
      }
    case 'SET_NEW_RUN':
      return {
        ...state,
        newRun: action.payload.newRun,
      }
    case 'GET_FINAL_RUN':
      return {
        ...state,
        finalRun: action.payload.finalRun,
      }
    case 'GET_ORDERS':
      return {
        ...state,
        orders: action.payload.orders,
      }
    case 'REDIRECT_TO_VARIANCE':
      return {
        ...state,
        redirect: action.payload.redirect,
      }
    case'GET_ORDERSS':
      return {
        ...state,
        orders: action.payload.data.data,
      }
    case 'SET_COMPLETED_RUN':
      return {
        ...state,
        completed: action.payload.completed,
      }
    case 'GET_PENDING_TASKS':
      return{
        ...state,
        tasks: action.payload.data
      }
    case 'GET_STATUS_OF_DMS':
      return {
        ...state,
        status:action.payload.data
      }
    case 'CLEAR_STATUS_OF_DMS':
      return {
        ...state,
        status: ''
      }
    case 'SET_NEW_VARIANCE':
      return{
        ...state,
        newVariance: action.payload.variance
      }
    case 'ADD_STATUS_FILTER':
      return {
        ...state,
        statusFilterList: new FilterSet(state.statusFilterList.getSet()).add(
            action.payload
        ),
      };
    case 'REMOVE_STATUS_FILTER':
      return {
        ...state,
        statusFilterList: new FilterSet(),
      };
    case 'GET_PARTS':
      return {
        ...state,
        parts: action.payload,
      };
    case 'SET_PRICE_FILTER_VALUE':
      return {
        ...state,
        priceFilterValue: action.payload,
      };
    default:
      return state
  }
}
